// frontend/src/components/common/Input.jsx
import React from 'react'
import { clsx } from 'clsx'

const Input = ({ 
  className = '', 
  error = false, 
  label, 
  ...props 
}) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input
        className={clsx(
          'w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent',
          error && 'border-danger-500 focus:ring-danger-500',
          className
        )}
        {...props}
      />
    </div>
  )
}

export default Input